"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkToggleDevourIQResponseToJSON = exports.BulkToggleDevourIQResponseFromJSONTyped = exports.BulkToggleDevourIQResponseFromJSON = void 0;
function BulkToggleDevourIQResponseFromJSON(json) {
    return BulkToggleDevourIQResponseFromJSONTyped(json, false);
}
exports.BulkToggleDevourIQResponseFromJSON = BulkToggleDevourIQResponseFromJSON;
function BulkToggleDevourIQResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dryRun': json['dryRun'],
        'updatedCount': json['updatedCount'],
    };
}
exports.BulkToggleDevourIQResponseFromJSONTyped = BulkToggleDevourIQResponseFromJSONTyped;
function BulkToggleDevourIQResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dryRun': value.dryRun,
        'updatedCount': value.updatedCount,
    };
}
exports.BulkToggleDevourIQResponseToJSON = BulkToggleDevourIQResponseToJSON;
